import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from '@mui/material';
import { prettyFloat } from 'webui/utils/number';
export function TariffAmountLabel(props) {
    const { config, loading_tariff, loading_status, tariff, sim_status } = props;
    if (loading_tariff || tariff == null) {
        return _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 20 });
    }
    const usage_amount = () => {
        if (loading_status || sim_status == null) {
            return (_jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 14, width: 20, sx: { display: 'inline-block' } }));
        }
        return prettyFloat(sim_status?.usage_counters[config.key], 2);
    };
    const tariff_amount = tariff[config.key];
    return (_jsxs(_Fragment, { children: [_jsx("span", { children: usage_amount() }), tariff_amount > 0 ? (_jsx("span", { children: '/' + tariff[config.key] + ' ' + config.unit })) : (_jsx("span", { children: '/' + '∞' + ' ' + config.unit }))] }));
}
